import { Grid, useTheme } from '@mui/material'
import { Stepper } from '..'
import { useBrand } from '../../utils/brand'
import { StepType } from '../../utils/sharedTypes'
import { IperiaFormDefaultState } from '../../utils/constants'
import IperiaAllRegistrationsLink from './IperiaAllRegistrationsLink'

type EdumiamHeaderProps = {
  steps?: StepType[]
}

const EdumiamHeader = ({ steps = IperiaFormDefaultState.steps }: EdumiamHeaderProps) => {
  const theme = useTheme()
  const brand = useBrand()
  const { LogoComponent } = brand

  return (
    <Grid
      item
      container
      sx={{
        display: { xs: 'block', sm: 'none' },
        pt: 2,
        pl: 2,
        pr: 2,
        background: theme.palette.primary.light,
        height: 100,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Grid item container justifyContent="space-between" alignItems="center" wrap="nowrap" spacing={1}>
        <Grid item sx={{ minWidth: 0 }}>
          <LogoComponent
            width={160}
            height={44}
            style={{ display: 'block', overflow: 'visible' }}
            onClick={() => {
              window.open(brand.websiteUrl, '_self')
            }}
          />
        </Grid>
        <Grid item sx={{ flexShrink: 0 }}>
          <IperiaAllRegistrationsLink />
        </Grid>
      </Grid>
      <Stepper steps={steps} />
    </Grid>
  )
}

export default EdumiamHeader
